/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'mail': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" d="M10.3 13.81a3.51 3.51 0 100-7.02 3.51 3.51 0 000 7.02zm0 1.551a5.062 5.062 0 113.51-8.709V5.538a.3.3 0 01.3-.3h.951a.3.3 0 01.3.3v7.619c0 .832.74 1.314 1.67 1.061 1.25-.34 2.047-1.766 2.016-3.918a8.748 8.748 0 10-3.552 7.037.3.3 0 01.42.063l.566.766a.3.3 0 01-.063.42 10.259 10.259 0 01-6.119 2.013C4.611 20.599 0 15.988 0 10.299 0 4.611 4.611 0 10.3 0c5.687 0 10.299 4.61 10.299 10.288.042 2.825-1.176 4.889-3.16 5.428-1.643.446-3.171-.385-3.544-1.853A5.05 5.05 0 0110.3 15.36z" _fill="#203F6A" fill-rule="nonzero"/>'
  }
})
